import lightFormat from 'date-fns/lightFormat';
import parseISO from 'date-fns/parseISO';

export default (date?: string | number | Date | null): string => {
  if (!date) return '';
  if (typeof date === 'string') date = parseISO(date);
  if (date.toString() === 'Invalid Date') return '';
  return lightFormat(date, 'h:mm aaa');
};
